import { render, staticRenderFns } from "./BaseMultiSourceSection.vue?vue&type=template&id=f6b2ddc0&scoped=true"
import script from "./BaseMultiSourceSection.vue?vue&type=script&lang=js"
export * from "./BaseMultiSourceSection.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiSourceSection.vue?vue&type=style&index=0&id=f6b2ddc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b2ddc0",
  null
  
)

export default component.exports